'use client';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '../components/button';

const AllFertilityArticles = () => {
    const [fertilityArticles, setFertilityArticles] = useState([]);

    useEffect(() => {
        const fetchFertilityArticles = async () => {
            try {
                // Requête API pour récupérer les articles de la catégorie Fertilité
                const res = await axios.get(
                    `${process.env.NEXT_PUBLIC_BASE_URL}/api/articles?published=true&category=${encodeURIComponent('Fertilité')}&sort=date:desc&limit=3&timestamp=${new Date().getTime()}`,
                    {
                        headers: {
                            'Cache-Control': 'no-cache'
                        }
                    }
                );

                // Les articles sont déjà filtrés par le backend
                const filteredArticles = res.data;

                // Calcul du temps de lecture pour chaque article
                const articlesWithReadingTime = filteredArticles.map(article => {
                    const wordCount = calculateWordCount(article.content);
                    const readingTime = Math.ceil(wordCount / 200); // 200 mots par minute
                    return {
                        ...article,
                        readingTime // Ajout du temps de lecture
                    };
                });

                // Mise à jour de l'état avec les articles filtrés et enrichis
                setFertilityArticles(articlesWithReadingTime);
            } catch (error) {
                // Gestion des erreurs avec log pour le débogage
                console.error("Erreur lors de la récupération des articles sur la fertilité :", error);
            }
        };

        // Fonction utilitaire pour compter les mots d'un contenu HTML
        const calculateWordCount = (content) => {
            const text = content.replace(/<[^>]*>/g, ''); // Supprime les balises HTML
            return text.split(" ").filter(word => word.length > 0).length; // Compte les mots
        };

        fetchFertilityArticles(); // Appel de la fonction asynchrone
    }, []); // Dépendances vides pour exécuter l'effet uniquement au montage


    const getBadgeStyle = (category) => {
        switch (category) {
            case 'Fertilité':
                return {
                    gradient: 'from-emerald-600 via-emerald-500 to-teal-500',
                    icon: '🌱',
                    shadow: 'shadow-emerald-200'
                };
            case 'Perte de poids':
                return {
                    gradient: 'from-emerald-500 via-teal-400 to-cyan-400',
                    icon: '⚖️',
                    shadow: 'shadow-emerald-200'
                };
            case 'Troubles hormonaux':
                return {
                    gradient: 'from-slate-600 via-slate-500 to-gray-500',
                    icon: '⚖️',
                    shadow: 'shadow-slate-200'
                };
            default:
                return {
                    gradient: 'from-gray-500 via-gray-400 to-slate-400',
                    icon: '📝',
                    shadow: 'shadow-gray-200'
                };
        }
    };

    const truncateDescription = (description) => {
        if (description.length > 250) {
            return `${description.substring(0, 250)}...`;
        }
        return description;
    };

    return (
        <div className="fertility-articles-section">
            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-8 p-4 md:p-0">
                {fertilityArticles.map((article) => {
                    const { gradient, icon, shadow } = getBadgeStyle(article.category);
                    return (
                        <div key={article._id} className="article-card bg-white border border-[#D4DDD1] shadow-md rounded-3xl p-6 relative transition-transform transform hover:scale-[1.02] hover:shadow-2xl flex flex-col">
                            <div className="relative aspect-video overflow-hidden rounded-2xl">
                                {article.imageUrl && (
                                    <Image
                                        src={article.imageUrl}
                                        alt={article.title}
                                        fill
                                        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                                        className="object-cover"
                                    />
                                )}
                                <div className="absolute top-3 right-3">
                                    <span className={`bg-gradient-to-r ${gradient} text-white px-4 py-2 rounded-full text-xs font-bold shadow-lg ${shadow} hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center gap-2 backdrop-blur-sm`}>
                                        <span className="text-base">{icon}</span>
                                        <span>{article.category}</span>
                                    </span>
                                </div>
                            </div>

                        <p className="text-sm text-gray-600 mt-1">Temps de lecture : {article.readingTime} min | Publié le : {new Date(article.publishedDate || article.date).toLocaleDateString()}</p>
                        <h3 className="text-xl font-semibold mt-4 break-words">{article.title}</h3>
                        <p className="mt-2">{truncateDescription(article.description)}</p>

                        <div className="mt-auto pt-4 flex justify-center">
                            <Button
                                onClick={() => window.location.href = `/articles/${article.slug}`}
                            >
                                Lire...
                            </Button>
                        </div>
                    </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AllFertilityArticles;



